import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
  Pagination,
} from "react-bootstrap";
// import { FaArrowLeft, FaArrowRight, FaEye, FaPrint } from "react-icons/fa";
import { ArrowLeft, ArrowRight, Eye, FileEarmarkArrowUp, Printer } from "react-bootstrap-icons";
import Select from 'react-select';
import Header from '../../layouts/Header';
import axiosInstance from '../../api/axios';
import { useNavigate } from "react-router-dom";

const RmStockReport = () => {
  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);
  const navigate = useNavigate();
  
  const accessToken = localStorage.getItem("authToken");
  const [stockReportsList, setStockReportsList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [mainCategoryRawMateialList, setMainCategoryRawMateialList] = useState([]);
  const [subCategoryRawMaterials, setSubCategoryRawMaterials] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [rmMainCategoryId, setRMMainCategoryId] = useState("");
  const [rmMainCategoryName, setRMMainCategoryName] = useState("All Main Category");
  const [rmSubCategoryId, setRMSubCategoryId] = useState("");
  const [rmSubCategoryName, setRMSubCategoryName] = useState("All Sub Category")
  const [pageNumber, setPageNumber] = useState(1);
  const [recordsValue, setRecordsValue] = useState("20");
  const [totalPages, setTotalPages] = useState(0);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [rawMaterialId, setrawMaterialId] = useState('');
  const [singleRmData, setSingleRmData] = useState([]);
  const [printReportsData, setPrintReportsData] = useState([]);
  const [printBtnLoading, setPrintBtnLoading] = useState(false);
  const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
  const [tableDataLoading, setTableDataLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState({});

  const handleDownloadExcel = async() => {
    setDownloadBtnLoading(true);
    // const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
    // const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
    getAllStockReports(true, rmMainCategoryId, rmSubCategoryId, rmMainCategoryName, rmSubCategoryName);
  }

  const getAllStockReports = async (download, mainCategory, subCategory, mainName, subName) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      // let newurl = `stock-transactions/getCurrentStock?page=1&limit=${recordsValue}`
      let newurl =  `stock-transactions/getCurrentCentralStock?page=1&limit=${recordsValue}`;
      
      if (download) {
        newurl += `&isDownload=${download}`
      }

      if (mainCategory && subCategory) {
        newurl += `&mainRMCategoryId=${mainCategory}&subRMCategoryId=${subCategory}`
      }

      if (mainCategory && subCategory === '') {
        newurl += `&mainRMCategoryId=${mainCategory}`
      }

      if (subCategory && mainCategory === '') {
        newurl += `&subRMCategoryId=${subCategory}`
      }
      
      const response = await axiosInstance.get(
        newurl,
        { 
          headers,
          responseType: download ? 'blob' : 'json' 
        }
      );

      console.log("Response of report :", response);
      

      if (download) {
          // Create a blob from the response data
          const blob = new Blob([response.data], { 
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          });
          
          // Create a link element
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          
          // Set the filename for the download
          const fileName = `Central Stock Report of ${mainName} & ${subName} Raw Materials.xlsx`;
          link.download = fileName;
          
          // Append the link to the body and trigger the download
          document.body.appendChild(link);
          link.click();
          
          // Clean up
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
  
          toast.success('Excel file downloaded successfully!', {
              position: "top-right",
              autoClose: 3000,
              theme: "light"
          });
      }

      if (response?.data?.status === true) {
        console.log("Hello 1");
        
        setStockReportsList(response?.data?.data?.data);
        setFilteredData(response?.data?.data?.data);
        setTotalPages(response?.data?.data?.pagination?.totalPages);
      }
    } catch (error) {
      console.log("Error in Reports :", error);
      
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    } finally {
      setDownloadBtnLoading(false);
      setLoading(false);
    }
  };

  const getAllStockReportsWithoutPagination = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axiosInstance.get(
        `stock-transactions/getCurrentCentralStock`,
        { headers }
      );

      if (response?.data?.data?.status === true) {
        console.log("Hello 2");
        setPrintReportsData(response?.data?.data?.data);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };

  const getMainCategoryRawMaterials = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axiosInstance.get("masters/rm-main-category/get", {
        headers,
      });

      if (response?.data?.status === true) {
        setMainCategoryRawMateialList(response?.data?.data?.categories);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };

  const getSubCategoryRawMaterials = async (id) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await axiosInstance.get("masters/rm-sub-category/get", {
        headers,
      });
      if (response?.data?.status === true) {
        setSubCategoryRawMaterials(response?.data?.data?.categories);
        setFilteredSubCategories(response?.data?.data?.categories);
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };

  const handleMainCategoryChange = (e) => {
    console.log("e of main category :", e);
    
    setRMMainCategoryName(e.target.label);
    setRMMainCategoryId(e.target.value);

    const result =
      e.target.value !== ""
        ? subCategoryRawMaterials.filter(
          (item) => item?.mainCategory === e.target.value
        )
        : subCategoryRawMaterials;
    setFilteredSubCategories(result);
  };

  const handleFilter = async (e) => {
    e.preventDefault();
    setIsFilterLoading(true);

    const hasMainCategoryId = rmMainCategoryId !== "";
    const hasSubCategoryId = rmSubCategoryId !== "";

    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };

      // let url = "stock-transactions/getCurrentStock";
      let url = "stock-transactions/getCurrentCentralStock";

      if (hasMainCategoryId && hasSubCategoryId) {
        url += `?mainRMCategoryId=${rmMainCategoryId}&subRMCategoryId=${rmSubCategoryId}`;
      } else if (hasMainCategoryId) {
        url += `?mainRMCategoryId=${rmMainCategoryId}`;
      } else if (hasSubCategoryId) {
        url += `?subRMCategoryId=${rmSubCategoryId}`;
      }

      if (recordsValue !== "2000") {
        if (url.includes('?')) {
          url += `&page=${pageNumber}&limit=${recordsValue}`;
        } else {
          url += `?page=${pageNumber}&limit=${recordsValue}`;
        }
      }

      const response = await axiosInstance.get(url, { headers });

      if ( response?.data?.status === true && response?.data?.data?.data !== "No Records" ) {
        console.log("Hello 3");
        
        setStockReportsList(response?.data?.data?.data);
        setFilteredData(response?.data?.data?.data);
        setTotalPages(response?.data?.data?.pagination?.totalPages);
      } else {
        toast.error(response?.data?.data?.totalRecords);
        setRMMainCategoryId("");
        setRMSubCategoryId("");
      }
    } catch (error) {
      if (error.response && error.response?.data?.status === false) {
        let errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    } finally {
      setIsFilterLoading(false);
    }
  };

  const handlePrevClick = () => {
    const prevPage = Math.max(pageNumber - 1, 1);
    setPageNumber(prevPage);
    setTableDataLoading(true);
    pagination(prevPage, recordsValue);
  };

  const handleNextClick = async () => {
    const nextPage = pageNumber + 1;
    if (nextPage <= totalPages) {
      setTableDataLoading(true);
      setPageNumber(nextPage);
      pagination(nextPage, parseInt(recordsValue, 10));
    } else {
      toast.error("Already on the last page");
    }
  };

  const pagination = async (pageNumber, recordsValue) => {
    try {
      // let apiEndpoint = "stock-transactions/getCurrentStock";
      let apiEndpoint = `stock-transactions/getCurrentCentralStock`
      const queryParams = {
        page: pageNumber,
        limit: recordsValue,
      };

      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };

      const response = await axiosInstance.get(apiEndpoint, {
        params: queryParams,
        headers: headers,
      });

      if (response?.data?.status === true) {
        console.log("Hello 4");
        setStockReportsList(response?.data?.data?.data);
        setFilteredData(response?.data?.data?.data);
        setTotalPages(response?.data?.data?.pagination?.totalPages);
      } else {
        toast.error("No records found");
      }
    } catch (error) {
      if (error.response && error.response.status === 404 && error.response.data) {
        toast.error("No customer records found");
      } else {
        let errorMessage = "An error occurred while fetching customers list.";
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message;
        }
        toast.error(errorMessage);
      }
    } finally {
      setTableDataLoading(false);
    }
  };

  const handleOpenViewModal = (data) => {
    console.log("Open View Modal :", data);
    
    setOpenViewModal(true);
    setrawMaterialId(data?._id);
    getSingleStockReportDetails(data?._id);
    setDetails(data);
  }

  const getSingleStockReportDetails = async (rmId) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`
      }
      const response = await axiosInstance.get(`stock-transactions/central-outlet-transaction?rawMaterialId=${rmId}`, { headers });
      setSingleRmData(response?.data?.data?.records);
    } catch (error) {
      toast.error(error.message);
    }
  }

  const handlePrintReport = async() => {
    setPrintBtnLoading(true);
    await getAllStockReportsWithoutPagination();
    setPrintBtnLoading(false);

    const tableContent = `
      <table style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr style="font-size: 12px">
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Sr.No</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Fin. Year</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Raw Material Name</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">RM Main Category</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">RM Sub Category</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Credited Quantity</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Debited Quantity</th>
            <th style="border: 1px solid black; padding: 8px; text-align: left;">Balance</th>
          </tr>
        </thead>
        <tbody>
          ${printReportsData?.length > 0 ? 
            printReportsData?.map((stockInfo, index) => `
              <tr style="font-size: 11px">
                <td style="border: 1px solid black; padding: 8px;">${index + 1}</td>
                <td style="border: 1px solid black; padding: 8px; width: 60px">${stockInfo?.currentFinancialYear}</td>
                <td style="border: 1px solid black; padding: 8px;">${stockInfo?.rawMaterial?.name}</td>
                <td style="border: 1px solid black; padding: 8px;">${stockInfo?.rawMaterial?.mainCategory?.name}</td>
                <td style="border: 1px solid black; padding: 8px; width: 100px">${stockInfo?.rawMaterial?.subCategory?.name}</td>
                <td style="border: 1px solid black; padding: 8px;">${stockInfo?.totalCreditQuantity}</td>
                <td style="border: 1px solid black; padding: 8px;">${stockInfo?.totalDebitQuantity}</td>
                <td style="border: 1px solid black; padding: 8px;">${stockInfo?.stockInfo}</td>
              </tr>
            `).join("") :
            `<tr>
              <td colspan="8" style="border: 1px solid black; padding: 8px; text-align: center;">No Customers Found</td>
            </tr>`
          }
        </tbody>
      </table>
    `;

    const win = window.open("", "", "width=900,height=600");
    win.document.write(`
      <html>
        <head>
          <title>Raw Materials Stock Report</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body onload="window.print();window.close()">
          <h2 style="text-align: center; margin-bottom: 20px;">Raw Materials Stock Report</h2>
          <div>${tableContent}</div>
        </body>
      </html>
    `);
    win.document.close();
  }

  const handleRecordsPerChange = (lim) => {
    setTableDataLoading(true);
    pagination(pageNumber, lim);
  }

  useEffect(() => {
    getAllStockReports();
    getMainCategoryRawMaterials();
    getSubCategoryRawMaterials();
  }, []);

  useEffect(() => {
    const result = stockReportsList?.filter((item) => {
      return (
        item?.rawMaterialName?.toLowerCase().match(searchText.toLocaleLowerCase()) ||
        item?.unit?.toLowerCase().match(searchText.toLocaleLowerCase()) ||
        item?.totalCurrentStock?.toString().includes(searchText) ||
        item?.totalCredit?.toString().includes(searchText) ||
        item?.totalDebit?.toString().includes(searchText) ||
        (item?.financialYear && item?.financialYear?.toString().includes(searchText))
      );
    });
    setFilteredData(result);
  }, [searchText]);

  // useEffect(() => {
  //   rawMaterialId && getSingleStockReportDetails();
  // }, [rawMaterialId]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
              <Card className="mb-4 shadow-sm">
                {/* <Card.Header className="bg-primary text-white"> */}
                    <Card.Header className="bg-primary text-white py-2 d-flex justify-content-between align-items-center">
                      <Card.Title as="h5" className="mb-0 d-flex align-items-center">
                          <i className="bi bi-people-fill me-2"></i>RAW MATERIALS CENTRAL STOCK REPORT
                      </Card.Title>
                      <Button
                          variant="outline-light" 
                          size="sm" 
                          onClick={() => navigate('/reports/all-reports')}
                          className="d-flex align-items-center fw-semibold"
                          style={{ height: '38px' }}
                      >
                          <ArrowLeft className="me-1" /> Back to Reports
                      </Button>
                    </Card.Header>
                    {/* <Card.Title as="h5" className="mb-0">RAW MATERIALS CENTRAL STOCK REPORT</Card.Title> */}
                {/* </Card.Header> */}
                <Card.Body>
                    <Form onSubmit={handleFilter}>
                        <Row className="mb-3">
                            <Col md={4} lg={2} className="d-flex align-items-center mb-3">
                                <div className="w-100 text-center text-white py-2 rounded me-2" style={{ background: "#6c757d" }}>
                                    Page No.
                                </div>
                                <Form.Control
                                    type="number"
                                    min={1}
                                    value={pageNumber}
                                    onChange={(e) => setPageNumber(e.target.value)}
                                    className="no-arrows"
                                />
                            </Col>
                            <Col md={4} lg={2}>
                                <Form.Select
                                    value={recordsValue}
                                    onChange={(e) => {
                                      setRecordsValue(e.target.value);
                                      handleRecordsPerChange(e.target.value);
                                    }}
                                >
                                    <option value="">Select Records</option>
                                    <option value="20">20</option>
                                    <option value="40">40</option>
                                    <option value="60">60</option>
                                    <option value="80">80</option>
                                    <option value="100">100</option>
                                    <option value="2000">ALL</option>
                                </Form.Select>
                            </Col>
                            <Col md={4} lg={3}>
                                <Select
                                    options={mainCategoryRawMateialList?.map((rm) => ({
                                        value: rm._id,
                                        label: rm.name,
                                    }))}
                                    value={
                                        rmMainCategoryId
                                        ? {
                                            value: rmMainCategoryId,
                                            label: mainCategoryRawMateialList?.find((rm) => rm._id === rmMainCategoryId)?.name,
                                            }
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                        handleMainCategoryChange({
                                        target: { name: "rmMainCategoryId", value: selectedOption ? selectedOption.value : "", label: selectedOption ? selectedOption?.label : "All Main Category" },
                                        });
                                    }}
                                    classNamePrefix="react-select"
                                    isClearable
                                    placeholder="Select Main Category"
                                />
                            </Col>
                            <Col md={4} lg={3}>
                                <Select
                                    options={filteredSubCategories?.map((rm) => ({
                                        value: rm._id,
                                        label: rm.name,
                                    }))}
                                    value={
                                        rmSubCategoryId
                                        ? {
                                            value: rmSubCategoryId,
                                            label: filteredSubCategories?.find((rm) => rm._id === rmSubCategoryId)?.name,
                                            }
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                        setRMSubCategoryId(selectedOption ? selectedOption.value : "");
                                        setRMSubCategoryName(selectedOption ? selectedOption.label : "All Sub Category" )
                                    }}
                                    classNamePrefix="react-select"
                                    isClearable
                                    placeholder="Select Sub Category"
                                />
                            </Col>
                            <Col md={4} lg={2}>
                                <Button variant="primary" type="submit" className="w-100" style={{ fontWeight: '500' }}>
                                    SHOW
                                </Button>
                            </Col>
                        </Row>
                    </Form>

                    <Row>
                        <Col md="4" lg="4">
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    placeholder="Search by item name..."
                                />
                                <button className="btn btn-primary" type="button">
                                    <i className="ri-search-line"></i>
                                </button>
                            </div>
                        </Col>
                        <Col md="3" lg="3">
                            <Button variant="outline-success" onClick={handleDownloadExcel} className="d-flex align-items-center fw-semibold w-75 justify-content-center">
                                <FileEarmarkArrowUp className="me-2" /> 
                                {downloadBtnLoading ? <Spinner size="sm" animation="border" className="me-2" /> :  "Export Report"}
                            </Button>
                        </Col>
                    </Row>

                    <div className="table-responsive">
                        <Table striped bordered hover className="mt-3">
                            <thead className="bg-primary text-white">
                                <tr>
                                    <th>#</th>
                                    <th>FIN.YEAR</th>
                                    <th>ITEM NAME</th>
                                    <th>RM CATEGORY</th>
                                    <th>CREDIT QTY</th>
                                    <th>DEBITED QTY</th>
                                    <th>BALANCE</th>
                                    <th>ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                              {(tableDataLoading || isFilterLoading || loading) ? (
                                  <tr>
                                    <td colSpan="8" className="text-center">
                                      <Spinner animation="border" className="text-primary" />
                                    </td>
                                  </tr>
                                ) : filteredData?.length > 0 ? (
                                  filteredData.map((row, index) => (
                                    <tr key={index}>
                                      <td>
                                        {recordsValue === "2000"
                                          ? index + 1
                                          : (pageNumber - 1) * recordsValue + index + 1}
                                      </td>
                                      <td>{row?.financialYear || "--------"}</td>
                                      <td>
                                        <div>{row?.rawMaterialName || "--------"}</div>
                                        <div
                                          style={{
                                            color:
                                              row?.status === "IN STOCK"
                                                ? "green"
                                                : row?.status === "OUT OF STOCK"
                                                ? "red"
                                                : "yellowgreen",
                                          }}
                                        >
                                          {row?.status || "--------"}
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <span style={{ color: "purple" }}>
                                            {row?.mainRMCategoryName || "--------"}
                                          </span>{" "}
                                          {" >> "} <br />
                                          <span style={{ color: "blue" }}>
                                            {row?.subRMCategoryName || "--------"}
                                          </span>
                                        </div>
                                      </td>
                                      <td>
                                        {row?.totalCredit?.toFixed(2) || 0}{" "}
                                        <small>{row?.unit || ""}</small>
                                      </td>
                                      <td>
                                        {row?.totalDebit?.toFixed(2) || 0}{" "}
                                        <small>{row?.unit || ""}</small>
                                      </td>
                                      <td>
                                        {row?.totalCurrentStock?.toFixed(2) || 0}{" "}
                                        <small>{row?.unit || ""}</small>
                                      </td>
                                      <td className="text-center">
                                        <Button
                                          variant="link"
                                          size="sm"
                                          onClick={() => handleOpenViewModal(row)}
                                          className="text-info p-0"
                                        >
                                          <Eye className="me-1" /> View
                                        </Button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="8" className="text-center">
                                      No records found
                                    </td>
                                  </tr>
                                )
                              }

                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-end gap-3 align-items-center">
                        <div className="d-flex align-items-center">
                            <span className="me-2 fw-semibold">Records per page:</span>
                            <Form.Select
                                value={recordsValue}
                                onChange={(e) => {
                                    setRecordsValue(e.target.value)
                                    handleRecordsPerChange(e.target.value)
                                  }
                                }
                                style={{ width: '80px' }}
                                size="sm"
                            >
                                <option value="20">20</option>
                                <option value="40">40</option>
                                <option value="60">60</option>
                                <option value="80">80</option>
                                <option value="100">100</option>
                                <option value="2000">All</option>
                            </Form.Select>
                        </div>
                        
                        <div className="d-flex align-items-center">
                            <Button
                                variant="outline-primary"
                                disabled={pageNumber === 1}
                                onClick={handlePrevClick}
                                className="d-flex align-items-center me-2 fw-semibold"
                                size="sm"
                            >
                                <ArrowLeft className="me-1" /> Previous
                            </Button>

                            <span className="mx-2 fw-semibold">
                                Page {pageNumber} of {totalPages}
                            </span>

                            <Button
                                variant="outline-primary"
                                onClick={handleNextClick}
                                disabled={pageNumber >= totalPages}
                                className="d-flex align-items-center fw-semibold"
                                size="sm"
                            >
                                Next <ArrowRight className="ms-1" />
                            </Button>
                        </div>
                    </div>
                </Card.Body>
              </Card>

                {openViewModal ? (
                  <Modal
                    show={openViewModal}
                    onHide={() => setOpenViewModal(false)}
                    size="xl"
                    centered
                  >
                    <Modal.Header closeButton className="bg-primary text-white">
                      <Modal.Title>Raw Material Stock Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {/* Raw Material Info */}
                      {details && (
                        <div className="mb-4">
                          <h5 className="mb-3">Raw Material Summary</h5>
                          <Table bordered>
                            <tbody>
                              <tr>
                                <th>Name</th>
                                <td>{details?.rawMaterialName}</td>
                                <th>Main Category & Sub Category</th>
                                <td>{details?.mainRMCategoryName} / {details?.subRMCategoryName}</td>
                              </tr>
                              <tr>
                                <th>Total Credit</th>
                                <td>{details?.totalCredit} {details?.unit}</td>
                                <th>Total Debit</th>
                                <td>{details?.totalDebit} {details?.unit}</td>
                              </tr>
                              <tr>
                                <th>Current Stock</th>
                                <td colSpan="3">{details?.totalCurrentStock} {details?.unit}</td>
                              </tr>
                              <tr>
                                <th>Status</th>
                                <td colSpan="3" style={{color: details?.status === "IN STOCK" ? "green" : "red"}}>
                                  {details?.status}
                                </td>
                              </tr>
                            </tbody>
                          </Table>

                          {/* Storage location breakdown */}
                          <h6 className="mt-4">Stock by Storage Location</h6>
                          <Table bordered striped>
                            <thead className="bg-light">
                              <tr>
                                <th>Storage Location</th>
                                <th>Credited Qty</th>
                                <th>Debited Qty</th>
                                <th>Current Stock</th>
                              </tr>
                            </thead>
                            <tbody>
                              {details?.details?.length > 0 ? (
                                details.details.map((loc, idx) => (
                                  <tr key={idx}>
                                    <td>{loc?.storageLocationName}</td>
                                    <td>{loc?.creditedQty}</td>
                                    <td>{loc?.debitedQty}</td>
                                    <td>{loc?.currentStock}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="4" className="text-center text-danger">No storage location data</td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      )}

                      {/* Existing transfer details table */}
                      <div className="table-responsive">
                        <h5 className="mb-3">Transfer History</h5>
                        <Table striped bordered hover>
                          <thead className="bg-dark text-white">
                            <tr>
                              <th>Financial Year</th>
                              <th>Outlet Name</th>
                              <th>Raw Material Name</th>
                              <th>Stock Transfered To Outlet</th>
                              <th>From Storage Location</th>
                              <th>Outlet Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {singleRmData?.length > 0 ? (
                              singleRmData.map((rmData, index) => (
                                <tr key={index}>
                                  <td>{rmData?.financialYear}</td>
                                  <td>{rmData?.outlet?.name}</td>
                                  <td>{rmData?.rawMaterial?.name}</td>
                                  <td>{rmData?.totalQuantity} {rmData?.rawMaterial?.unit}</td>
                                  <td>
                                    <span className="fw-semibold">{rmData?.storageLocation?.name}</span>
                                    <br />
                                    <span className="text-muted">
                                      {rmData?.storageLocation?.city}, {rmData?.storageLocation?.state}.
                                    </span>
                                  </td>
                                  <td style={{ color: rmData?.outlet?.status === "ACTIVE" ? "green" : "red", fontWeight: '500' }}>
                                    {rmData?.outlet?.status}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center text-danger">
                                  <strong>No records found</strong>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button 
                        onClick={() => setOpenViewModal(false)}
                        variant="danger"
                        style={{
                            outline: "none",
                            border: "none",
                        }}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                ) : null}

                
            </div>
        </React.Fragment>
    );
};

export default RmStockReport;